<style>
    .sorry {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 1.5rem;
        height: 100%;
        max-width: 400px;
        margin: 0 auto;
    }
    .sorry__header {
        margin: 2rem auto;
    }
    .sorry__lead {
        margin-bottom : 4rem;
        max-width: 15ch;
    }
    .sorry__qr {
        width: 100%;
    }
</style>
<div class="sorry">
    <img class="sorry__header" width="94" src="./assets/svg/logo_text.svg" alt="Originea">
    <h1 class="sorry__lead">Sorry, you need to use a mobile device.</h1>
    <img class="sorry__qr" src="./assets/svg/qr_code.svg" alt="Scan QR Code">
    <p>Scan QR code with your camera</p>
</div>